module.exports = __webpack_public_path__ + "img/paibian-mu.3313da10.png";